import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { useMountEffect, useUpdateEffect } from "../../../hooks/LifeCycle";
import useEmpresa from "../../../hooks/useEmpresa";
import AuthActions from "../../../stores/auth/Actions";
import AfiliadoFarmaCardActions from "../../../stores/afiliadoFarmaCard/Actions";
import PrestadorActions from "../../../stores/prestador/Actions";
import MedicamentoActions from "../../../stores/medicamento/Actions";
import CatalogoActions from "../../../stores/catalogo/Actions";
import { useLocation } from "react-router-dom";
import MedicamentoForm from "../components/MedicamentoForm";
import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import AfiliadoForm from "../components/AfiliadoForm";
import MedicamentosModal from "../components/MedicamentosModal";
import CustomButton from "../../../components/CustomButton/CustomButton";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import CustomModal from "../../../components/CustomModal/CustomModal";
import { formatCedula, isEmptyValue } from "../../../utils/StringUtil";
import { cleanNumber } from "../../../utils/NumberUtil";
import { getAge } from "../../../utils/DateUtils";
import { mostrarErrorGenerico } from "../../../utils/AlertUtils";
import { isObjectEmpty } from "../../../utils/ObjectUtil";
import CustomTable from "../../../components/CustomTable/CustomTable";
import CustomFileUpload from "../../../components/CustomFileUpload/CustomFileUpload";
import TittleLine from "../../../components/Common/TittleLine";
import {
  MedicamentoFormButtonsContainer,
  MedicamentoFormButtonsRight,
  MedicamentoFormButtonsLeft,
} from "../styles/MedicamentoStyles";
import {
  INITIAL_STATE_MEDICAMENTO_FORM,
  PAGINAS_MEDICAMENTOS,
  columnsMedicamentosAgregados,
  columnsMedicamentosPermitidos,
  DATOS_FIJOS_ZONAS,
  DATOS_FIJOS_PROVINCIAS,
  DEFAULT_ICON_AVATAR,
} from "../utils/MedicamentoConstant";
import { EMPRESA, PROGRAMA } from "../../../utils/Constant";
import { generarVoucherHTML } from "../utils/MedicamentoUtils";
import { CODIGO_TIPO_SERVICIO_MEDICAMENTO } from "../utils/MedicamentoConstant";
import { ALERTAS_GENERICAS } from "../../../utils/AlertasGenericas";
import CustomAlert from "../../../components/Common/CustomAlert";
import CheckRender from "../../../components/Common/CheckRender";
import ModalLoader from "../../../components/Common/ModalLoader";
import {
  isValidPhone,
  isValidEmail,
  isValidNumber,
  camposCompletos,
} from "../../../utils/ValidationUtil";
import Colors from "../../../themes/Colors";
import { getActualYear } from "../../../utils/DateUtils";
import {
  cleanCurrency,
  formatearMontoPesos,
} from "../../../utils/CurrencyUtil";
import { TIPO_DOCUMENTO_CORE } from "../../../utils/LocalData";
import moment from "moment";

const AutorizacionScreen = (props) => {
  const empresa = useEmpresa();
  const location = useLocation();
  const { prestador } = props?.authUserData;
  const [formData, setFormData] = useState(INITIAL_STATE_MEDICAMENTO_FORM);
  const [isModalMedicamentosOpen, setIsModalMedicamentosOpen] = useState(false);
  const [isModalDocumentosOpen, setIsModalDocumentosOpen] = useState(false);
  const [queryMedicamentos, setQueryMedicamentos] = useState("");
  const [queryAfiliado, setQueryAfiliado] = useState("");
  const [queryDocumento, setQueryDocumento] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertConfig, setAlertConfig] = useState({});
  const [processing, setProcessing] = useState(false);
  const [showRequired, setShowRequired] = useState(false);
  const [autorizacionEsPyp, setAutorizacionEsPyp] = useState(false);
  const [medicamentosBusqueda, setMedicamentosBusqueda] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [listaProvincias, setListaProvincias] = useState([]);
  const [, setSelectedMedico] = useState(null);
  const [, setSelectedDiagnostico] = useState(null);
  const itemsPerPage = PAGINAS_MEDICAMENTOS.TAMANO;
  const [currentPageMedicamentos, setCurrentPageMedicamentos] = useState(1);
  const [isQueryAfiliado, setIsQueryAfiliado] = useState(false);
  const [excedeCoberturaDisponible, setExcedeCoberturaDisponible] =
    useState(false);
  const [showAlertCoberturaExcedida, setShowAlertCoberturaExcedida] =
    useState(false);
  const [tablaMedicamentosData, setTablaMedicamentosData] = useState([]);
  const [isReadOnlyAfterReclamacion, setIsReadOnlyAfterReclamacion] =
    useState(false);
  const [showNuevaReclamacionButton, setShowNuevaReclamacionButton] =
    useState(false);
  const [nuevaReclamacionDisabled, setNuevaReclamacionDisabled] =
    useState(true);
  const diagnosticoSearchTimeoutRef = useRef(null);

  const isPrimera = empresa?.CODIGO === EMPRESA.PRIMERA.CODIGO;

  const esPilotoSam = props?.authUserData?.esPilotoSam;

  useMountEffect(() => {
    cleanAndLoadResources();
    validarConfiguracionPapperFree();
    validarConfiguracionPyp();
  });

  /**
   * Obtener nueva sesión Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.nuevaSesionData) && processing) {
      const { tipoDocumento } = formData;

      limpiarFormulario();

      props.consultarAfiliadoFarmaCard({
        queryAfiliado,
        tipoDocumento,
        codigoPss: prestador?.codigo,
      });
    }
  }, [props.nuevaSesionData]);

  /**
   * Obtener nueva sesión Error.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.nuevaSesionError) && processing) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.nuevaSesionError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.nuevaSesionError]);

  /**
   * Consultar afiliadoFarmaCard Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.consultarAfiliadoFarmaCardData) && processing) {
      setProcessing(false);

      if (
        !empresaPuedeAutorizar(
          props?.consultarAfiliadoFarmaCardData?.cod_poliza?.substring(0, 2)
        )
      ) {
        setAlertConfig({
          type: "confirm",
          title: "¡Hola!",
          message: `${empresa?.REDIRECT_COMPANY.MESSAGE}`,
          confirmText: `Ir a ${empresa?.REDIRECT_COMPANY.NAME}`,
          onConfirm: () => {
            const newTab = window.open(empresa?.REDIRECT_COMPANY.URL, "_blank");
            newTab.focus();
            setShowAlert(false);
          },
          onCancel: () => {
            setShowAlert(false);
          },
        });

        props.limpiarDatosAfiliado();

        setShowAlert(true);
        return;
      }

      const {
        carnet,
        nombres,
        apellidos,
        cedula,
        nss,
        fecha_nacimiento,
        plan,
      } = props?.consultarAfiliadoFarmaCardData || {};

      setQueryAfiliado(carnet);

      if (isQueryAfiliado) {
        setQueryDocumento(cedula);
      }

      setFormData((prevState) => {
        return {
          ...prevState,
          numeroAfiliado: carnet,
          cedula: formatCedula(cedula),
          nss: nss,
          nombres: nombres,
          apellidos: apellidos,
          edad: getAge(fecha_nacimiento),
          plan: plan,
          foto: DEFAULT_ICON_AVATAR,
          esSuplementario: prevState.esSuplementario,
          tipoDocumento: isQueryAfiliado
            ? TIPO_DOCUMENTO_CORE.CEDULA
            : prevState.tipoDocumento,
        };
      });
    }
  }, [props.consultarAfiliadoFarmaCardData]);

  /**
   * Consultar afiliadoFarmaCard Error.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.consultarAfiliadoFarmaCardError) && processing) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.consultarAfiliadoFarmaCardError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.consultarAfiliadoFarmaCardError]);

  /**
   * Obtener listado provincias Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.getProvinciasData) && processing) {
      const { provincias } = props?.getProvinciasData;
      setListaProvincias(provincias || []);
    }
  }, [props.getProvinciasData]);

  /**
   * Buscar medicamentos OrdsInfoplan Success.
   */
  useUpdateEffect(() => {
    if (
      !isObjectEmpty(props?.buscarMedicamentosOrdsInfoplanData) &&
      processing
    ) {
      setProcessing(false);
      const { items } = props?.buscarMedicamentosOrdsInfoplanData;
      setMedicamentosBusqueda(items || []);
    }
  }, [props.buscarMedicamentosOrdsInfoplanData]);

  /**
   * Buscar medicamentos OrdsInfoplan Error.
   */
  useUpdateEffect(() => {
    if (
      !isObjectEmpty(props?.buscarMedicamentosOrdsInfoplanError) &&
      processing
    ) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.buscarMedicamentosOrdsInfoplanError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.buscarMedicamentosOrdsInfoplanError]);

  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.notificarReclamacionData) && processing) {
      setProcessing(false);

      const descripcion =
        props?.notificarReclamacionData?.descripcion ||
        props?.notificarReclamacionData?.respuesta?.descripcion ||
        "Reclamación enviada exitosamente";

      const numeroReclamacion =
        props?.notificarReclamacionData?.data?.reclamacion || null;

      setAlertConfig({
        type: "success",
        title: "¡Éxito!",
        message: descripcion,
        onConfirm: () => {
          setIsReadOnlyAfterReclamacion(true);
          setShowNuevaReclamacionButton(true);
          setNuevaReclamacionDisabled(false);
          setShowAlert(false);
        },
        showSecondaryButton: numeroReclamacion !== null,
        secondaryButtonLabel: "Generar Voucher",
        onSecondaryButtonClick: () => {
          handleGenerarVoucherHTML();
        },
      });
      setShowAlert(true);
    }
  }, [props.notificarReclamacionData]);

  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.notificarReclamacionError) && processing) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.notificarReclamacionError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.notificarReclamacionError]);

  const cleanAndLoadResources = () => {
    props.limpiarDatosAfiliado();

    // props.limpiarDatosAutorizacion();

    props.clearSesion();

    props.getDiagnosticos({ Pagina: 1, Tamanio: 10 });

    if (prestadorTieneConfiguradoPapperFree()) {
      props.getZonas({
        paisId: DATOS_FIJOS_ZONAS.PAIS_ID,
        tipoDistribucionPoliticaId:
          DATOS_FIJOS_ZONAS.TIPO_DISTRIBUCION_POLITICA_ID,
      });
    }
  };

  const empresaPuedeAutorizar = (codigoEmpresaAfiliadoFarmaCard) => {
    return (
      Number(empresa?.CODIGO) === Number(codigoEmpresaAfiliadoFarmaCard) ||
      autorizacionEsPyp
    );
  };

  const prestadorTieneConfiguradoPapperFree = () => {
    return props?.authUserData?.configuracionPaperFree?.esPaperFree;
  };

  const validarConfiguracionPapperFree = () => {
    if (prestadorTieneConfiguradoPapperFree()) {
      setFormData((prevState) => {
        return {
          ...prevState,
          requiereFisico: "No",
        };
      });
    }
  };

  const validarConfiguracionPyp = () => {
    let program = location?.state?.program;

    if (!program) {
      let search = window.location.search;
      let params = new URLSearchParams(search);
      program = params.get("program");
    }

    const esPyp =
      program === PROGRAMA.PROMOCION_PREVENCION.CODIGO &&
      prestador.pyp &&
      isPrimera;

    setAutorizacionEsPyp(esPyp);

    if (esPyp) {
      setFormData((prevState) => {
        return {
          ...prevState,
          tipoServicio: CODIGO_TIPO_SERVICIO_MEDICAMENTO.PROMOCION_PREVENCION,
        };
      });
    }
  };

  const noRequiereFisico = () => {
    return formData?.requiereFisico === "No";
  };

  const getTitulo = () => {
    return "Agregar Reclamación de medicamentos";
  };

  const handleOpenModalDocumentos = () => {
    setIsModalDocumentosOpen(true);
  };

  const handleCloseModalDocumentos = () => {
    setIsModalDocumentosOpen(false);
  };

  const validarFormularioAutorizacion = () => {
    if (!afiliadoEncontrado()) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: `Recuerda que primero debes hacer la búsqueda de el ${empresa?.TIPO_CLIENTE}.`,
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
      return false;
    }

    if (!camposRequeridosCompletos()) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: ALERTAS_GENERICAS.CAMPOS_REQUERIDOS,
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
      setShowRequired(true);
      return false;
    }

    const { telefono, correo } = formData;

    if (
      !isValidPhone(telefono) ||
      (!isEmptyValue(correo) && !isValidEmail(correo))
    ) {
      return;
    }

    return true;
  };

  const afiliadoEncontrado = () => {
    return !isObjectEmpty(props?.consultarAfiliadoFarmaCardData);
  };

  const camposRequeridosCompletos = () => {
    const {
      fecha,
      tipoTelefono,
      telefono,
      tipoServicio,
      zona,
      provincia,
      diagnostico,
    } = formData;

    if (noRequiereFisico()) {
      return camposCompletos({
        fecha,
        tipoTelefono,
        telefono,
        tipoServicio,
        zona,
        provincia,
        diagnostico,
      });
    }

    return camposCompletos({
      fecha,
      tipoTelefono,
      telefono,
      tipoServicio,
    });
  };

  const tieneMedicamentosAgregados = () => {
    return tablaMedicamentosData?.length > 0;
  };

  const handleValueChange =
    (key, format = null) =>
    (value, applyFilter = true) => {
      setFormData((prevState) => {
        return {
          ...prevState,
          [key]: format ? format(value) : value,
        };
      });

      if (key === "zona") {
        setFormData((prevState) => {
          return {
            ...prevState,
            provincia: "",
          };
        });

        if (isEmptyValue(value)) {
          setListaProvincias([]);
        } else {
          setProcessing(true);
          props.getProvincias({
            paisId: DATOS_FIJOS_PROVINCIAS.PAIS_ID,
            tipoDistribucionPoliticaId:
              DATOS_FIJOS_PROVINCIAS.TIPO_DISTRIBUCION_POLITICA_ID,
            distribucionPoliticaSuperiorId: Number(value),
          });
        }
      }

      if (key === "medicoPrescriptor") {
        if (applyFilter && prestadorTieneConfiguradoPapperFree()) {
          consultarMedicos(value);
        }
      }

      if (key === "diagnostico") {
        if (applyFilter) {
          consultarDiagnosticos(value);
        }
      }

      if (key === "diagnosticoDefinitivo") {
        setFormData((prevState) => {
          return {
            ...prevState,
            [key]: value?.target?.checked,
          };
        });
      }

      if (key === "tipoDocumento") {
        setQueryDocumento("");
      }
    };

  const handleCheckboxChange = (key) => (value) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [key]: value?.target?.checked,
      };
    });
  };

  const consultarMedicos = (value) => {
    if (isEmptyValue(value)) {
      return;
    }

    if (isValidNumber(value)) {
      props.getMedicos({ codigoMedico: value });
      return;
    }

    if (value.length >= 3) {
      props.getMedicos({ nombreMedico: value });
    }
  };

  const DEBOUNCE_DIAGNOSTICOS_MS = 350;
  const consultarDiagnosticos = (value) => {
    if (diagnosticoSearchTimeoutRef.current) {
      clearTimeout(diagnosticoSearchTimeoutRef.current);
    }
    diagnosticoSearchTimeoutRef.current = setTimeout(() => {
      props.getDiagnosticos({
        Pagina: 1,
        Tamanio: 20,
        Buscar: value != null && String(value).trim() !== "" ? String(value).trim() : null,
      });
      diagnosticoSearchTimeoutRef.current = null;
    }, DEBOUNCE_DIAGNOSTICOS_MS);
  };

  const onQueryAfiliadoChange = () => (value) => {
    if (formData.tipoDocumento === TIPO_DOCUMENTO_CORE.PASAPORTE) {
      setQueryAfiliado(value);
      return;
    }
    setQueryAfiliado(cleanNumber(value));

    setQueryDocumento("");
  };

  const onQueryDocumentoChange = () => (value) => {
    if (formData.tipoDocumento === TIPO_DOCUMENTO_CORE.PASAPORTE) {
      setQueryDocumento(value);
      return;
    }
    setQueryDocumento(cleanNumber(value));

    setQueryAfiliado("");
  };

  const construirObjetoReclamacion = () => {
    const afiliadoData = props?.consultarAfiliadoFarmaCardData || {};
    const {
      cod_poliza = "",
      cod_afiliado = "",
      cod_persona = "",
      plan = "",
      cobertura_tipo = "",
      copago = 0,
    } = afiliadoData;

    const { cedulaSuministrada, telefono, correo } = formData;

    const medicamentos = tablaMedicamentosData.filter(
      (item) => item.key !== 0 && item.key !== "0"
    );

    const montoTotalPagado = medicamentos.reduce((total, item) => {
      return total + parseFloat(item.montoAutorizado || 0);
    }, 0);

    const idRef = `HU-${Date.now()}${Math.floor(Math.random() * 1000)}`;

    const compania = cod_poliza ? parseInt(cod_poliza.substring(0, 2), 10) : 30;
    const ramo =
      cod_poliza && cod_poliza.length >= 4
        ? parseInt(cod_poliza.substring(2, 4), 10)
        : 95;
    const secPol =
      cod_poliza && cod_poliza.length >= 5
        ? parseInt(cod_poliza.substring(4), 10)
        : 0;

    const fechaActual = moment().format("YYYY-MM-DD");
    const anioActual = getActualYear();

    const reclamante = prestador?.codigo || 0;
    const tipAUso =
      cod_persona === "0" || cod_persona === 0 ? "ASEGURADO" : "DEPENDIENT";
    const dependiente = parseInt(cod_persona || "0", 10);
    const numPla = parseInt(plan || "0", 10);
    const aseUso = parseInt(cod_afiliado || "0", 10);

    const coberturas = medicamentos.map((medicamento) => {
      return {
        tipo_servicio: 1,
        tip_cob: parseInt(cobertura_tipo || "77", 10),
        mon_rec: parseFloat(medicamento.montoReclamado || 0),
        mon_pag: parseFloat(medicamento.montoAutorizado || 0),
        mon_ded: 0,
        por_coa: parseInt(copago || 0, 10),
        cobertura: parseInt(medicamento.codigo || 0, 10),
        frecuencia: parseInt(medicamento.cantidad || 0, 10),
      };
    });

    const objetoReclamacion = {
      llave: "4263374582E793E5E06375CF18AC3C8E",
      anio: anioActual,
      cedula_suministrada: cedulaSuministrada || "",
      monto_total: montoTotalPagado,
      id_ref: idRef,
      compania: compania,
      fecha_apertura: fechaActual,
      fecha_servicio: fechaActual,
      reclamante: reclamante,
      tipo_reclamante: "NO_MEDICO",
      ramo: ramo,
      usuario_ingreso: "WEBSALUD",
      ase_uso: aseUso,
      sec_pol: secPol,
      dependiente: dependiente,
      num_pla: numPla,
      tip_a_uso: tipAUso,
      cod_recla_farmacard: idRef,
      cod_inte_farmacard: idRef,
      comentario: `${idRef}. Generado desde websalud.`,
      plastico: parseInt(formData.numeroAfiliado || "0", 10),
      prescribiente: "",
      cod_diagnostico: 0,
      desc_diagnostico: "",
      tel_asegurado: cleanNumber(telefono || ""),
      email_asegurado: correo || "",
      coberturas: coberturas,
    };

    return objetoReclamacion;
  };

  const handleGenerarVoucherHTML = async () => {
    await generarVoucherHTML(
      props?.consultarAfiliadoFarmaCardData || {},
      props?.notificarReclamacionData || {},
      tablaMedicamentosData,
      empresa,
      Colors,
      moment,
      formatearMontoPesos,
      prestador?.nombre,
      prestador?.codigo
    );
  };

  const enviarAutorizacion = () => {
    if (!validarFormularioAutorizacion()) {
      return;
    }

    if (!tieneMedicamentosAgregados()) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: "Favor agregar los medicamentos.",
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
      return;
    }

    setAlertConfig({
      type: "confirm",
      title: "¿Estás seguro?",
      message: "¿Deseas enviar la reclamación?",
      onConfirm: () => {
        setShowAlert(false);
        const objetoReclamacion = construirObjetoReclamacion();
        const numeroSesion = props?.nuevaSesionData?.numeroSesion;

        setProcessing(true);
        props.notificarReclamacion({
          numeroSesion,
          requestData: objetoReclamacion,
        });
      },
      onCancel: () => {
        setShowAlert(false);
      },
    });
    setShowAlert(true);
  };

  const onSearchAfiliado = () => {
    if (isEmptyValue(queryAfiliado)) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: `Favor ingresar número de ${empresa?.TIPO_CLIENTE}`,
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
      return;
    }

    setIsQueryAfiliado(true);

    setProcessing(true);

    props.nuevaSesion({
      codigo: prestador?.codigo,
    });
  };

  const onSearchDocumento = () => {
    if (isEmptyValue(queryDocumento)) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: `Favor ingresar número de documento.`,
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
      return;
    }

    setIsQueryAfiliado(false);

    setProcessing(true);

    props.nuevaSesion({
      codigo: prestador?.codigo,
    });
  };

  const onCleanForm = () => {
    setAlertConfig({
      type: "confirm",
      title: "¿Estás seguro?",
      message: `Recuerda que si limpias los datos tendrás que iniciar desde cero.`,
      onConfirm: () => {
        limpiarFormulario();
        setQueryAfiliado("");
        setQueryDocumento("");
        setShowAlert(false);
      },
      onCancel: () => {
        setShowAlert(false);
      },
    });
    setShowAlert(true);
  };

  const limpiarFormulario = () => {
    setFormData((prevState) => {
      return {
        ...prevState,
        ...INITIAL_STATE_MEDICAMENTO_FORM,
        tipoDocumento: formData.tipoDocumento,
      };
    });

    setTablaMedicamentosData([]);

    setExcedeCoberturaDisponible(false);

    props.limpiarDatosAfiliado();

    validarConfiguracionPapperFree();

    validarConfiguracionPyp();
  };

  const handleOpenModalMedicamentos = () => {
    if (!validarFormularioAutorizacion()) {
      return;
    }

    setIsModalMedicamentosOpen(true);
    setCurrentPageMedicamentos(1);
    setQueryMedicamentos("");
  };

  const handleCloseModalMedicamentos = () => {
    setIsModalMedicamentosOpen(false);
    setQueryMedicamentos("");
    setMedicamentosBusqueda([]);
  };

  const onQueryMedicamentosChange = () => (value) => {
    setQueryMedicamentos(value);
    // Limpiar resultados si el campo está vacío
    if (!value || value.trim().length === 0) {
      setMedicamentosBusqueda([]);
    }
  };

  const onSearchMedicamentos = (descripcion) => {
    if (descripcion && descripcion.trim().length > 0) {
      buscarMedicamentos(descripcion.trim());
    }
  };

  const buscarMedicamentos = (descripcion) => {
    const numeroSesion = props?.nuevaSesionData?.numeroSesion;

    setProcessing(true);
    props.buscarMedicamentosOrdsInfoplan({
      descripcion,
      offset: (currentPageMedicamentos - 1) * itemsPerPage,
      limit: itemsPerPage,
      numeroSesion,
    });
  };

  const agregarMedicamentoDesdeModal = (record) => {
    if (!validarFormularioAutorizacion()) {
      return;
    }

    const { codigo, descripcion } = record;

    if (medicamentoYaExiste(codigo)) {
      return;
    }

    if (!verificarCoberturaDisponible()) {
      setShowAlertCoberturaExcedida(true);
      return;
    }

    setTablaMedicamentosData((pre) => {
      return [
        ...pre,
        {
          key: codigo,
          codigo: codigo,
          descripcion: descripcion,
          cantidad: "",
          montoReclamado: "",
          montoAutorizado: 0,
          montoDiferencia: 0,
        },
      ];
    });

    handleCloseModalMedicamentos();
  };

  const onChangeCantidadMedicamento = (key, value) => {
    setTablaMedicamentosData((pre) =>
      pre.map((item) =>
        item.key === key ? { ...item, cantidad: cleanNumber(value) } : item
      )
    );
  };

  const calcularTotalMontosAutorizados = (
    medicamentosData,
    excludeKey = null
  ) => {
    return medicamentosData
      .filter((item) => item.key !== 0 && item.key !== excludeKey)
      .reduce((total, item) => {
        return total + parseFloat(item.montoAutorizado || 0);
      }, 0);
  };

  const onChangeMontoReclamadoMedicamento = (key, value) => {
    const copago = props?.consultarAfiliadoFarmaCardData?.copago || 0;
    const coberturaDisponible =
      props?.consultarAfiliadoFarmaCardData?.cobertura_disponible || 0;
    const montoReclamado = parseFloat(cleanCurrency(value) || 0);
    const porcentajeCoaseguro = copago / 100;
    let montoAutorizado = montoReclamado - montoReclamado * porcentajeCoaseguro;

    const totalMontosAutorizadosOtros = calcularTotalMontosAutorizados(
      tablaMedicamentosData,
      key
    );
    const montoDisponibleRestante =
      coberturaDisponible - totalMontosAutorizadosOtros;

    if (montoAutorizado > montoDisponibleRestante) {
      montoAutorizado = Math.max(0, montoDisponibleRestante);
      setExcedeCoberturaDisponible(true);
      setShowAlertCoberturaExcedida(true);
    } else {
      const nuevoTotal = totalMontosAutorizadosOtros + montoAutorizado;
      if (nuevoTotal > coberturaDisponible) {
        setExcedeCoberturaDisponible(true);
        setShowAlertCoberturaExcedida(true);
      } else {
        setExcedeCoberturaDisponible(false);
        setShowAlertCoberturaExcedida(false);
      }
    }

    const montoDiferencia = montoReclamado - montoAutorizado;

    setTablaMedicamentosData((pre) => {
      const nuevosDatos = pre.map((item) =>
        item.key === key
          ? {
              ...item,
              montoReclamado: cleanCurrency(value),
              montoAutorizado: montoAutorizado,
              montoDiferencia: montoDiferencia,
            }
          : item
      );

      setTimeout(() => {
        verificarCoberturaDisponible(nuevosDatos);
      }, 0);

      return nuevosDatos;
    });
  };

  const medicamentoYaExiste = (codigoMedicamento) => {
    if (
      tablaMedicamentosData.some(
        (medicamento) => medicamento.codigo === codigoMedicamento
      )
    ) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: `El medicamento ${codigoMedicamento} ya fue agregado.`,
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
      return true;
    }

    return false;
  };

  const verificarCoberturaDisponible = (medicamentosData = null) => {
    const datosAVerificar =
      medicamentosData !== null ? medicamentosData : tablaMedicamentosData;
    const coberturaDisponible =
      props?.consultarAfiliadoFarmaCardData?.cobertura_disponible || 0;
    const totalMontosAutorizados =
      calcularTotalMontosAutorizados(datosAVerificar);

    if (totalMontosAutorizados >= coberturaDisponible) {
      setExcedeCoberturaDisponible(true);
      return false;
    }

    setExcedeCoberturaDisponible(false);
    return true;
  };

  const eliminarMedicamento = (record) => {
    setAlertConfig({
      type: "confirm",
      title: "¿Estás seguro?",
      message: `¿Deseas eliminar el medicamento ${record?.codigo}?`,
      onConfirm: () => {
        setTablaMedicamentosData((pre) => {
          const nuevosDatos = pre.filter((item) => item.key !== record?.key);
          setTimeout(() => {
            verificarCoberturaDisponible(nuevosDatos);
          }, 0);
          return nuevosDatos;
        });
        setShowAlert(false);
      },
      onCancel: () => {
        setShowAlert(false);
      },
    });
    setShowAlert(true);
  };

  const showModalLoader = () => {
    const {
      nuevaSesionLoading,
      consultarAfiliadoFarmaCardLoading,
      limpiarDatosAfiliadoFarmaCardLoading,
      buscarMedicamentosOrdsInfoplanLoading,
      notificarReclamacionLoading,
    } = props;

    return (
      nuevaSesionLoading ||
      consultarAfiliadoFarmaCardLoading ||
      limpiarDatosAfiliadoFarmaCardLoading ||
      buscarMedicamentosOrdsInfoplanLoading ||
      notificarReclamacionLoading
    );
  };

  const disableFields = () => {
    return showModalLoader() || isReadOnlyAfterReclamacion;
  };

  const tieneMedicamentosIncompletos = () => {
    const medicamentos = tablaMedicamentosData.filter(
      (item) => item.key !== 0 && item.key !== "0"
    );

    return medicamentos.some(
      (medicamento) =>
        isEmptyValue(medicamento.cantidad) ||
        isEmptyValue(medicamento.montoReclamado)
    );
  };

  const disableAgregarMedicamento = () => {
    if (excedeCoberturaDisponible) {
      return true;
    }

    return tieneMedicamentosIncompletos() || disableFields();
  };

  const disableEnviarReclamacion = () => {
    if (isReadOnlyAfterReclamacion) {
      return true;
    }

    return tieneMedicamentosIncompletos();
  };

  const handleNuevaReclamacion = () => {
    limpiarFormulario();
    setQueryAfiliado("");
    setQueryDocumento("");
    setIsReadOnlyAfterReclamacion(false);
    setNuevaReclamacionDisabled(true);
  };

  const processMedicamentosWithTotals = (medicamentos) => {
    if (!medicamentos || medicamentos.length === 0) {
      return [];
    }

    const medicamentosFiltered = medicamentos.filter(
      (item) => item.key !== 0 && item.key !== "0" && item.key !== "totales"
    );

    if (medicamentosFiltered.length === 0) {
      return medicamentos;
    }

    const medicamentosWithTotals = [...medicamentosFiltered];

    const lastRow = medicamentosWithTotals[medicamentosWithTotals.length - 1];
    if (lastRow && lastRow.descripcion !== "Totales") {
      const totalReclamado = medicamentosFiltered.reduce(
        (acumulador, medicamento) =>
          acumulador + parseFloat(medicamento.montoReclamado || 0),
        0
      );
      const totalAutorizado = medicamentosFiltered.reduce(
        (acumulador, medicamento) =>
          acumulador + parseFloat(medicamento.montoAutorizado || 0),
        0
      );
      const totalDiferencia = medicamentosFiltered.reduce(
        (acumulador, medicamento) =>
          acumulador + parseFloat(medicamento.montoDiferencia || 0),
        0
      );
      medicamentosWithTotals.push({
        key: "totales",
        codigo: "",
        descripcion: "Totales",
        cantidad: "",
        montoReclamado: totalReclamado,
        montoAutorizado: totalAutorizado,
        montoDiferencia: totalDiferencia,
      });
    }

    return medicamentosWithTotals;
  };

  const getAutorizationFormProps = () => {
    const {
      getZonasLoading,
      getProvinciasLoading,
      getDiagnosticosLoading,
      getMedicosLoading,
    } = props;

    return {
      data: formData,
      diagnosticos: props?.getDiagnosticosData?.diagnosticos || [],
      zonas: props?.getZonasData?.zonas || [],
      provincias: listaProvincias || [],
      medicos: props?.getMedicosData?.medicos || [],
      onStateChange: handleValueChange,
      handleCheckboxChange,
      showRequired: showRequired,
      disabled: disableFields(),
      noRequiereFisico: noRequiereFisico(),
      prestadorEsPapperFree: prestadorTieneConfiguradoPapperFree(),
      getZonasLoading,
      getProvinciasLoading,
      getDiagnosticosLoading,
      getMedicosLoading,
      updatedSuggestionsMedicos: props?.getMedicosData?.medicos,
      updatedSuggestionsDiagnosticos: formData.diagnostico?.trim()
        ? props?.getDiagnosticosData?.diagnosticos
        : undefined,
      autorizacionEsPyp,
    };
  };

  const getAfiliadoFormProps = () => {
    const {
      cedula,
      nss,
      nombres,
      apellidos,
      edad,
      tipoDocumento,
      foto,
      esSuplementario,
    } = formData;

    return {
      queryAfiliado: queryAfiliado,
      queryDocumento: queryDocumento,
      cedula,
      nss,
      nombres,
      apellidos,
      edad,
      tipoDocumento,
      foto,
      onStateChange: handleValueChange,
      onSearch: onSearchAfiliado,
      onSearchDocumento: onSearchDocumento,
      onClean: onCleanForm,
      onQueryAfiliadoChange: onQueryAfiliadoChange,
      onQueryDocumentoChange: onQueryDocumentoChange,
      esPilotoSam,
      esSuplementario,
      disabled: disableFields(),
    };
  };

  return (
    <CustomLayout
      showMenuNav={true}
      footerPosition={"relative"}
      footerWidth={"auto"}
    >
      <Section>
        <TittleLine title={getTitulo()} weight={"bold"} />
      </Section>

      <Section>
        <AfiliadoForm {...getAfiliadoFormProps()} />
      </Section>

      <Section padding={"5px"}>
        <MedicamentoForm {...getAutorizationFormProps()} />
      </Section>

      <Section align="center" flexDirection={"column"} padding={"10px"}>
        <CustomTable
          columns={columnsMedicamentosAgregados(
            handleOpenModalMedicamentos,
            eliminarMedicamento,
            empresa,
            onChangeCantidadMedicamento,
            onChangeMontoReclamadoMedicamento,
            isReadOnlyAfterReclamacion
          )}
          dataSource={processMedicamentosWithTotals(tablaMedicamentosData)}
          showPagination={false}
          pageSize={100}
          width={"200%"}
        />
      </Section>

      <Section>
        <TittleLine />
      </Section>

      <Section align={"center"} padding={"10px"}>
        <MedicamentoFormButtonsContainer>
          <MedicamentoFormButtonsLeft>
            <CustomButton
              label={"Agregar Medicamento"}
              onClick={handleOpenModalMedicamentos}
              disabled={disableAgregarMedicamento()}
              weight={"bold"}
              hoverColor={empresa?.COLOR_PRINCIPAL}
              bgColor={Colors.white}
              textColor={empresa?.COLOR_PRINCIPAL}
              border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
              disabledBgColor={Colors.greyLight}
              disabledTextColor={Colors.grayFont}
              disabledBorder={`1px solid ${Colors.grey}`}
            />
            <CustomSeparator width={"10px"} />
            <CheckRender allowed={noRequiereFisico()}>
              <CustomButton
                label={"Adjuntar Soportes"}
                onClick={handleOpenModalDocumentos}
                disabled={disableFields()}
                weight={"bold"}
                hoverColor={empresa?.COLOR_PRINCIPAL}
                bgColor={Colors.white}
                textColor={empresa?.COLOR_PRINCIPAL}
                border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
              />
            </CheckRender>
          </MedicamentoFormButtonsLeft>

          <MedicamentoFormButtonsRight>
            <CheckRender allowed={!isReadOnlyAfterReclamacion}>
              <CustomButton
                label={"Enviar Reclamación"}
                onClick={enviarAutorizacion}
                disabled={disableEnviarReclamacion()}
                bgColor={empresa?.COLOR_SECUNDARIO}
                hoverColor={empresa?.COLOR_PRINCIPAL}
                weight={"bold"}
                disabledBgColor={Colors.greyLight}
                disabledTextColor={Colors.grayFont}
                disabledBorder={`1px solid ${Colors.grey}`}
              />
              <CustomSeparator width={"10px"} />
              <CustomButton
                label={"Cancelar"}
                onClick={onCleanForm}
                disabled={disableFields()}
                weight={"bold"}
                hoverColor={Colors.huMyHealth}
                bgColor={Colors.white}
                textColor={Colors.huMyHealth}
                border={`1px solid ${Colors.huMyHealth}`}
              />
            </CheckRender>
            <CheckRender allowed={isReadOnlyAfterReclamacion}>
              <CustomSeparator width={"10px"} />
              <CustomButton
                label={"Nueva Reclamación"}
                onClick={handleNuevaReclamacion}
                disabled={nuevaReclamacionDisabled}
                weight={"bold"}
                hoverColor={empresa?.COLOR_PRINCIPAL}
                bgColor={Colors.white}
                textColor={empresa?.COLOR_PRINCIPAL}
                border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
                disabledBgColor={Colors.greyLight}
                disabledTextColor={Colors.grayFont}
                disabledBorder={`1px solid ${Colors.grey}`}
              />
              <CustomSeparator width={"10px"} />
              <CustomButton
                label={"Imprimir Voucher"}
                onClick={handleGenerarVoucherHTML}
                disabled={false}
                weight={"bold"}
                hoverColor={empresa?.COLOR_PRINCIPAL}
                bgColor={Colors.white}
                textColor={empresa?.COLOR_PRINCIPAL}
                border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
                disabledBgColor={Colors.greyLight}
                disabledTextColor={Colors.grayFont}
                disabledBorder={`1px solid ${Colors.grey}`}
              />
            </CheckRender>
          </MedicamentoFormButtonsRight>
        </MedicamentoFormButtonsContainer>
      </Section>

      <CustomModal
        isOpen={isModalMedicamentosOpen}
        onClose={handleCloseModalMedicamentos}
      >
        <MedicamentosModal
          query={queryMedicamentos}
          onQueryChange={onQueryMedicamentosChange}
          onSearch={onSearchMedicamentos}
          columnsMedicamentos={columnsMedicamentosPermitidos(
            agregarMedicamentoDesdeModal,
            empresa
          )}
          dataMedicamentos={medicamentosBusqueda}
          itemsPerPage={itemsPerPage}
        />
      </CustomModal>

      <CustomModal
        isOpen={isModalDocumentosOpen}
        onClose={handleCloseModalDocumentos}
      >
        <CustomFileUpload
          accept=".jpg,.png,.jpeg,.pdf"
          label="Documentos"
          multiple
          files={documents}
          setFiles={setDocuments}
          buttonColor={empresa?.COLOR_PRINCIPAL}
        />
      </CustomModal>

      <CheckRender allowed={showModalLoader()}>
        <ModalLoader />
      </CheckRender>

      <CheckRender allowed={showAlert}>
        <CustomAlert {...alertConfig} />
      </CheckRender>

      <CheckRender allowed={showAlertCoberturaExcedida}>
        <CustomAlert
          type="warning"
          title="¡Atención!"
          message="Ha excedido el monto disponible para autorización."
          onConfirm={() => {
            setShowAlertCoberturaExcedida(false);
          }}
        />
      </CheckRender>
    </CustomLayout>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  nuevaSesionData: state.auth.nuevaSesionData,
  nuevaSesionLoading: state.auth.nuevaSesionLoading,
  nuevaSesionError: state.auth.nuevaSesionError,

  consultarAfiliadoFarmaCardData:
    state.afiliadoFarmaCard.consultarAfiliadoFarmaCardData,
  consultarAfiliadoFarmaCardLoading:
    state.afiliadoFarmaCard.consultarAfiliadoFarmaCardLoading,
  consultarAfiliadoFarmaCardError:
    state.afiliadoFarmaCard.consultarAfiliadoFarmaCardError,

  limpiarDatosAfiliadoFarmaCardLoading:
    state.afiliadoFarmaCard.limpiarDatosAfiliadoFarmaCardLoading,

  buscarMedicamentosOrdsInfoplanData:
    state.medicamento.buscarMedicamentosOrdsInfoplanData,
  buscarMedicamentosOrdsInfoplanLoading:
    state.medicamento.buscarMedicamentosOrdsInfoplanLoading,
  buscarMedicamentosOrdsInfoplanError:
    state.medicamento.buscarMedicamentosOrdsInfoplanError,

  notificarReclamacionData: state.medicamento.notificarReclamacionData,
  notificarReclamacionLoading: state.medicamento.notificarReclamacionLoading,
  notificarReclamacionError: state.medicamento.notificarReclamacionError,

  getZonasData: state.catalogo.getZonasData,
  getZonasLoading: state.catalogo.getZonasLoading,
  getZonasError: state.catalogo.getZonasError,

  getProvinciasData: state.catalogo.getProvinciasData,
  getProvinciasLoading: state.catalogo.getProvinciasLoading,
  getProvinciasError: state.catalogo.getProvinciasError,

  getDiagnosticosData: state.catalogo.getDiagnosticosData,
  getDiagnosticosLoading: state.catalogo.getDiagnosticosLoading,
  getDiagnosticosError: state.catalogo.getDiagnosticosError,

  getMedicosData: state.prestador.getMedicosData,
  getMedicosLoading: state.prestador.getMedicosLoading,
  getMedicosError: state.prestador.getMedicosError,
});

const mapDispatchToProps = {
  nuevaSesion: AuthActions.nuevaSesion,
  clearSesion: AuthActions.clearSesion,
  consultarAfiliadoFarmaCard:
    AfiliadoFarmaCardActions.consultarAfiliadoFarmaCard,
  limpiarDatosAfiliado: AfiliadoFarmaCardActions.limpiarDatosAfiliadoFarmaCard,
  limpiarDatosAutorizacion: MedicamentoActions.limpiarDatosAutorizacion,
  getMedicos: PrestadorActions.getMedicos,
  buscarMedicamentosOrdsInfoplan:
    MedicamentoActions.buscarMedicamentosOrdsInfoplan,
  notificarReclamacion: MedicamentoActions.notificarReclamacion,
  getDiagnosticos: CatalogoActions.getDiagnosticos,
  getZonas: CatalogoActions.getZonas,
  getProvincias: CatalogoActions.getProvincias,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(AutorizacionScreen);
